export default __webpack_public_path__ + "media/images/paylogos/color/maestro@2x-9f22afe83d4dab8b2c23886c13fe4225.png";